import React, {  Component } from 'react';

export default class SessionStatusOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="noProductResultsFoundOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">Session</h2>
                    <p>Your session is expired. Please login again.</p>
					<div className="floatRight">
						<a className="blueButton noButton" onClick={this.props.logout}>Ok</a>
					</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/sessionStatusOverlayDialog.js